/**
 * Decides whether a catalog navigation entry displays its count.
 *
 * ---
 * 🧠 **Context**
 *
 * - Used by HeaderNav for catalog item counters.
 * - The suggestions route displays a nonzero count only when the notifier-expiry gate is enabled.
 *
 * ---
 * @example
 * ```ts
 * const visible = shouldShowSuggestionCount('/sugestoes-de-pedidos', 12, true);
 * ```
 *
 * ---
 * @function shouldShowSuggestionCount
 * @param {string} href - Catalog item destination.
 * @param {number | undefined} counter - Count associated with the catalog item.
 * @param {boolean} isSuggestionsProductNotifierExpired - Expiry gate used specifically by the suggestions entry.
 * @returns {boolean} Whether the item count should be displayed.
 */
export function shouldShowSuggestionCount(
	href: string,
	counter: number | undefined,
	isSuggestionsProductNotifierExpired: boolean,
) {
	if (!!counter && href === '/sugestoes-de-pedidos') return isSuggestionsProductNotifierExpired;

	return !!counter;
}
